module.exports = __webpack_public_path__ + "static/ask-accolade-a92ab1aceff70604fd021add98269e7e.gif";